export default __webpack_public_path__ + "static/media/charter_regular-webfont.60445100.eot";